import { supabase } from './supabase';

// Inloggningen till vårt API ligger i en cookie som gäller en timme. Appen
// förnyar den med jämna mellanrum, men om fliken legat i bakgrunden eller
// datorn sovit kan den hinna gå ut. Då svarar API:t 401 fast användaren
// fortfarande är inloggad.

let refreshing: Promise<boolean> | null = null;

/**
 * Förnyar inloggningen: /api/auth/session byter en utgången cookie mot en ny
 * med refresh-token, och klienten får samma nya token. Samtidiga anrop delar
 * på en förnyelse. Sant om användaren fortfarande är inloggad.
 */
export function refreshServerSession(): Promise<boolean> {
    if (!refreshing) {
        refreshing = (async () => {
            try {
                const res = await fetch('/api/auth/session', {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Cache-Control': 'no-cache' },
                });
                if (!res.ok) return false;
                const data = await res.json();
                if (!data?.authenticated || !data.session) return false;
                await supabase.auth.setSession(data.session);
                return true;
            } catch {
                return false;
            }
        })().finally(() => { refreshing = null; });
    }
    return refreshing;
}

/**
 * fetch mot vårt eget API. Svarar servern 401 förnyas inloggningen och
 * anropet görs en gång till. API:t svarar 401 innan något har gjorts, så
 * det är säkert att försöka igen.
 */
export async function apiFetch(url: string, init: RequestInit = {}): Promise<Response> {
    const options: RequestInit = { credentials: 'same-origin', ...init };
    const response = await fetch(url, options);
    if (response.status !== 401) return response;
    await refreshServerSession();
    return fetch(url, options);
}
